import { Controller } from "@hotwired/stimulus"
import { Tabs } from "flowbite"

// Connects to data-controller="flowbite-tabs"
export default class extends Controller {
  static targets = ["tab"]
  static values = {
    activeClasses: { type: String, default: "tg-primary-border tg-primary-text" },
    inactiveClasses: { type: String, default: "bg-white hover:text-gray-600 hover:bg-gray-50 hover:border-b-2 hover:border-b-gray-400" }
  }

  connect() {
    const parentElement = this.element;
    const tabElements = this.tabTargets.map((tab) => {
      return {
        id: tab.dataset.tabObjectId,
        triggerEl: document.getElementById(tab.dataset.tabTriggerId),
        targetEl: document.getElementById(tab.dataset.tabTargetId)
      }
    });
    const options = {
      defaultTabid: this.tabTargets[0].dataset.tabObjectId,
      activeClasses: this.activeClassesValue,
      inactiveClasses: this.inactiveClassesValue,
      onShow: (tab) => {
        this.dispatch('updateStore', { detail: { content: tab.getActiveTab().id } })
      }
    }

    this.tabs = new Tabs(parentElement, tabElements, options);
  }

  changeActiveTab({ detail: { content } }) {
    this.tabs.show(content)
  }
}
